export const COLORS: string[][] = [
    // Grey Colors
    ["#F9F9F7", "#ECECEC", "#E2E2E1", "#D0D0D0", "#A3A3A8", "#7B7B86", "#52535A", "#3A3A49", "#2C2C3C", "#1A1A2B", "#12131C"],
    // Red Colors
    ["#FFEBEA", "#FFCECA", "#FF9F92", "#FF6C4A", "#FF3C77", "#FF2B19", "#E0253A", "#BA162B", "#951608", "#641D1E", "#3D0000"],
    // Mango Colors
    ["#FFF0D6", "#FFDC80", "#FFCC33", "#F7B000", "#E68B00", "#FF5000", "#C74A00", "#9C3500", "#742C00", "#5A1B00", "#420000"],
    // Green Colors
    ["#F3FBE8", "#D7F1C2", "#AEDF93", "#78C65B", "#5DA32C", "#39A64D", "#1A9B59", "#027D5A", "#056B2B", "#1E4919", "#003312"],
    // Teal Colors
    ["#D1F8FA", "#7BC9CF", "#52A8A3", "#00BFCB", "#00A5A7", "#00736D", "#00787F", "#005F5C", "#00464D", "#003B3B", "#02352E"],
    // Blue Colors
    ["#EBF2FF", "#C7DEFF", "#A3C8FF", "#7FADFF", "#4D91FF", "#1B6EFF", "#0067FF", "#0053E2", "#0040BF", "#002E8B", "#001E66"],
    // Indigo Colors
    ["#F1E6FF", "#E2CBFF", "#CAB1FF", "#A48AFF", "#8667FF", "#6754FF", "#5547FF", "#3B2ED6", "#261FCC", "#1A0F88", "#0D0033"],
    // Pink Colors
    ["#FFE8F8", "#FFCCEB", "#FFA1DF", "#FF67D3", "#FF4FCC", "#FF1FB9", "#CC009C", "#A60081", "#820066", "#5B003F", "#320019"],
    // Raspberry Colors
    ["#FFEBF3", "#FFC4E0", "#FF98CE", "#F27DAF", "#F25495", "#F24582", "#CF275B", "#B83466", "#990050", "#73003A", "#52001A"],
    // Base Colors
    ["#FFFFFF", "#000000"]
  ];

  export const generateColors = (dayOfWeek: number) => {
    switch (dayOfWeek) {
      case 1:
        return 0
      case 2:
        return 2
      case 3:
        return 4
      case 4:
        return 6
      case 5:
        return 8
      default:
        return 0
    }
  }